import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import config from "../coreFIles/config";
import Header from '../directives/header';
import Leftnav from '../directives/leftSidebar';
import Rightnav from '../directives/rightSidebar';
import Footer from '../directives/footer';
import Cookies from 'js-cookie';
import Swal from "sweetalert2";
import {
    deleteadAction,
    adBlockUnBlockAction,
    repostAdsAction,
    bulkdeleteadAction,
    catDetailsAction,
    getSaveSearchHistoryAction

} from '../Action/action';
const Searchhistory = () => {
	// Style state for reactive styling
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			const storedStyle = Cookies.get('domainstyle');
			if (storedStyle) {
				try {
					setStyle(JSON.parse(storedStyle));
				} catch (error) {
					console.error('Error parsing style cookie:', error);
					setStyle([]);
				}
			} else {
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');


    const getLoginData = () => {
        try {
            const cookieData = Cookies.get('loginSuccessMember');
            return cookieData ? JSON.parse(cookieData) : null;
        } catch (error) {
            console.error('Error parsing loginSuccessMember cookie:', error);
            return null;
        }
    };
    const loginData = getLoginData();

    const [isLoading, setIsLoading] = useState(true);
    const [adData, setadData] = useState({});
    const [adsList, setAdsList] = useState([]);
    const [selectedAds, setSelectedAds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        if (!loginData) {
            window.location.href = `${config.baseUrl}`
        }
    }, [loginData]);

    useEffect(() => {
        getMemberAds();
    }, []);

    const sanitizeSlugPart = (value) => {
        if (!value) return '';
        return value.replace(/ /g, "-")
            .replace(/'/g, "")
            .replace(/&/g, "and")
            .replace(/[^A-Za-z0-9\-\']/g, '')
            .toLowerCase();
    };

    const handleAdRedirect = (row) => {
        if (!row?.id) return;
        const parentCategory = sanitizeSlugPart(row.parent_category_name || row.category_name || 'category');
        const category = sanitizeSlugPart(row.category_name || 'subcategory');
        const titleSlug = sanitizeSlugPart(row.title || 'ad');
        const pagenewUrl = `${config.baseUrl}ad/${row.id}/${parentCategory}-${category}-${titleSlug}`;
        //console.log(pagenewUrl);
        window.location.href = pagenewUrl;
    };

    const getMemberAds = async () => {
        setIsLoading(true);
        try {
            const res = await getSaveSearchHistoryAction({
                memberid: loginData.id,
            });
          
            if (res.data) {
                setAdsList(res.data);
                console.log(res.data)
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Could not load ads.", "error");
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            <Header />
            <div className="add-section mb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <Leftnav />
                        </div>
                        <div className="col-lg-6">
                            <div className="classification-section">
                                <h2 className="page-heading" style={{background:headerMenuColor}}>Search History</h2>
                                <div className="mt-3">
                                    <div className="table-responsive table-striped">
                                        <table className="table">
                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="7">
                                                            <div className="loaderDiv">
                                                                <img className="loaderImg" src={`${config.baseUrl}img/loader.gif`} alt="Loading..." height={50} width={50} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : adsList.length > 0 ? (
                                                    adsList.map((row,index) => (
                                                        <div key={index}  className= 'section-listing' id="searchhis">
                                                            <div className="main-item">
                                                                <div className="fast-block">
                                                                    <img
                                                                        src={row.addImg ? config.apiUrl + row.addImg : config.baseUrl + "img/noImage.png"}
                                                                        alt={row.title || 'Ad image'}
                                                                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                                                        onError={(e) => { e.target.onerror = null; e.target.src = config.baseUrl + "img/noImage.png"; }}
                                                                    />
                                                                </div>
                                                                <div className="second-block">
                                                                    <Link className="fordhead " to="javascript:;" onClick={() => handleAdRedirect(row)}>
                                                                        {row.title}
                                                                    </Link>

                                                                    {row.sell_price != 0 && row.sell_price != '' ? (
                                                                        <>
                                                                            <p><span><i className="fa-solid fa-dollar-sign"></i></span> ${row.sell_price}</p>
                                                                        </>
                                                                    ) : ''
                                                                    }


                                                                    <p><span><i className="fa-solid fa-location-dot"></i></span> {row.area} ({row.suburb})</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7">No search history found.</td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <Rightnav />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Searchhistory;
